import {Module} from '@fantasmagames/slot/src/common/Module';
import {View} from '@fantasmagames/slot/src/common/view/View';

export interface SimpleEventMap {
	[id: string]: Function;
}

/**
 * module state handles events
 */
export abstract class ModuleState<V extends View, M extends Module<V>> {
	protected get module(): M {
		return this._module;
	}

	protected get view(): V {
		return this._module.view;
	}

	public get name(): string {
		return this._name;
	}
	/**
	 * the list of events we handle with this state
	 */
	protected _events: SimpleEventMap = {};

	protected _name: string;

	protected _module: M;

	constructor(module: M, name: string) {
		this._module = module;
		this._name = name;

		this.setupEvents();
	}

	public removeMe(): void {
		if (this._events) {
			for (const event in this._events) {
				this._events[event] = null;
			}
		}
	}

	public abstract onEnterState(): void;

	public abstract onLeaveState(): void;

	/**
	 * handles events
	 * @param {number} id - event ID
	 * @param args
	 */
	public handle(id: string, ...args: any[]): void {
		this._events[id] && this._events[id](...args);
	}

	protected abstract setupEvents(): void;

	protected emit(id: string, ...args: any[]): void {
		this._module.eventManager.emit(id, ...args);
	}

	/**
	 * emitting event after the call stack if cleaned (next tick)
	 * @param id event id
	 * @param args arguments to pass with event
	 */
	protected emitDelayed(id: string, ...args: any[]): void {
		setTimeout(() => {
			this.emit(id, ...args);
		}, 0);
	}

	protected on(id: string, listener: Function): void {
		this._events[id] = listener.bind(this, id);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/ModuleState.ts